/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.runs.RunAction
*/
export var RunAction;
(function (RunAction) {
    RunAction["PAUSE"] = "PAUSE";
    RunAction["RESUME"] = "RESUME";
    RunAction["STOP"] = "STOP";
})(RunAction || (RunAction = {}));
//# sourceMappingURL=RunAction.js.map